import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          常见问答
        </h2>
        <div className="space-y-3">
          {faqData.map((item) => (
            <details
              key={item.id}
              className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 list-none">
                <h3 className="text-sm md:text-base text-foreground-800 font-medium pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-primary-400">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}